module.exports = __WEBPACK_EXTERNAL_MODULE_451__;


//////////////////
// WEBPACK FOOTER
// external "gemini/dashboard/layout/views/Widget"
// module id = 451
// module chunks = 0